import { DataBaseModelInterface } from '@solcre-org/core';

export class ClientModel implements DataBaseModelInterface {
  constructor(
    public id?: any,
    public commercialName?: string,
    public legalName?: string,
    public fiscalId?: string,
    public country?: string,
    public address?: string
  ) { }

  public fromJSON(json: any): ClientModel {
    if (json) {
      this.id = json.id;
      this.commercialName = json.commercialName;
      this.legalName = json.legalName;
      this.fiscalId = json.fiscalId;
      this.country = json.country;
      this.address = json.address;
    }
    return this;
  }

  public fromJSONList(json: any): ClientModel[] {
    if (json) {
      return json.map((element: any) => new ClientModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      commercialName: this.commercialName,
      legalName: this.legalName,
      fiscalId: this.fiscalId,
      country: this.country,
      address: this.address,
    };
  }

  public getId() {
    return this.id?.toString() ?? '';
  }

  public getReference() {
    return this.commercialName ?? '';
  }
}
